module.exports = __webpack_public_path__ + "pic_bizny_web_03-375@2x.png?1c5e29fa3ff354ea1f30a752425a5224";